import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Box,
} from "@mui/material";
import {
  ArrowDownward,
  ArrowUpward,
  Circle,
  Inventory,
} from "@mui/icons-material";
import { PriceDetailDialog } from "../PriceDetailDialog";
import { PriceDisplayBox } from "../../../inventory/components/PriceDisplayBox";
import { useTranslation } from "../../../../hooks/useTranslation";
import { ProductDetail } from "../types";
import { Section } from "./Section";

type PriceProps = {
  productDetail?: ProductDetail;
};

export const Price = ({ productDetail }: PriceProps) => {
  const { translate } = useTranslation("pages.product");

  return (
    <Section
      title={translate("price")}
      suffixIcon={
        <PriceDetailDialog
          minPriceInfo={productDetail?.minPrice}
          defaultPriceInfo={productDetail?.price}
          maxPriceInfo={productDetail?.maxPrice}
        />
      }
    >
      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell>{translate("minPrice")}</TableCell>
            <TableCell>
              <PriceDisplayBox
                price={productDetail?.minPrice?.finalPrice}
                color="green"
                StartIcon={ArrowDownward}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("price")}</TableCell>
            <TableCell>
              <PriceDisplayBox
                price={productDetail?.price?.finalPrice}
                color="green"
                StartIcon={Circle}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("maxPrice")}</TableCell>
            <TableCell>
              <PriceDisplayBox
                price={productDetail?.maxPrice?.finalPrice}
                color="green"
                StartIcon={ArrowUpward}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("stockCount")}</TableCell>
            <TableCell>
              <Box display="flex" alignItems="center">
                <Inventory
                  sx={{
                    margin: "4px 4px",
                    width: "16px",
                    height: "16px",
                    color: "gray",
                  }}
                />
                <Typography ml={1}>{productDetail?.stock}</Typography>
              </Box>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Section>
  );
};
